/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        var $mainBurger  = $("#main_burger");
        var $mainNav    = $(".nav-primary");
        var $brand      = $(".brand");
        $mainBurger.on("click", function(e) {
          $mainBurger.toggleClass("is-active");
          // Do something else, like open/close menu
          $brand.toggleClass("show");
          $mainNav.toggleClass("show");
        });

        var $subBurger  = $("#sub_burger");
        var $preNav  = $("#menu-preheader-navigation");
        $subBurger.on("click", function(e) {
          $subBurger.toggleClass("is-active");
          // Do something else, like open/close menu
          $preNav.toggleClass("showsub");
        });

        // progressive/responsive nav for preheader
        // from: http://jsfiddle.net/abhitalks/860LzgLL/
        /*
        var elemWidth, 
            elemHeight,
            fitCount, 
            fixedWidth = 120, 
            fixedHeight = 41, 
            $preheaderMenu = $("#menu-preheader-navigation"), 
            $collectedSet;

        function collect() {
          elemWidth = $preheaderMenu.width();
          elemHeight = $preheaderMenu.height();
          fitCount = Math.floor(elemHeight / fixedHeight) - 1;
          // fitCount = Math.floor(elemWidth / fixedWidth) - 1;
          // $collectedSet = $preheaderMenu.children(":gt(" + fitCount + ")");
          $collectedSet = $preheaderMenu.children(":gt(0)");
          $("#preheader-submenu").empty().append($collectedSet.clone());

          console.log(fitCount);
          console.log($collectedSet);
        }

        collect();
        $(window).resize(collect);
        */

        // searchbar in nav
        $(".menu-item.search-link").hover(
          function(){
            $("#searchbar").toggleClass('active');
          },
          function(){
            
            $("#searchbar").delay(8000).toggleClass('active');
          }
        );

        // lazy loading on images
        var bLazy = new Blazy({ 
          success: function(ele){
            // Image has loaded
            // Do your business here
            console.log("loaded.");
          }, 
          error: function(ele, msg){
            if(msg === 'missing'){
              // Data-src is missing
              console.log("missing.");
            }
            else if(msg === 'invalid'){
              // Data-src is invalid
              console.log("invalid.");
            }  
          }
        });

        // Smooth scrolling using jQuery easing
        $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname){
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
              $('html, body').animate({
                // scrollTop: (target.offset().top - 70)
                scrollTop: (target.offset().top)
              }, 1000, "easeInOutExpo");
              // $mainBurger.toggleClass("is-active");
              return false;
            }
          }
        });


        // lazy load carousel
        $('.carousel.lazy-load').on('slide.bs.carousel', function (e) {
          var image = $(e.relatedTarget).find('img[data-src]');
          image.attr('src', image.data('src'));
          image.removeAttr('data-src');
        });

        // not used. update in parent main.js
        Fancybox.bind("[data-fancybox]", {
          Thumbs: false,
          Toolbar: {
            display: {
              left: [],
              middle: [],
              right: ["close"],
            },
          },
        });

        // drawer nav
        $(".drawer-nav--item").on("click", function(){

          // close any open containers
          $(".drawer-nav--item").not($(this)).removeClass("active");
          $(".drawer-content").removeClass("active");
          
          $content = $(this).data("content");
          $contentID = $("#" + String($content));

          if ($(this).hasClass('active')){
            
            $(this).removeClass('active');
            // $contentID.slideToggle();
            $contentID.removeClass('active');

          } else {

            $(this).addClass('active');
            // $contentID.slideToggle();
            $contentID.addClass('active');

          }

        });

        var mediaPlayer = document.getElementById('bg-video');
        var home_carousel = $('#home_carousel');

        // var $mediaPlayer = $('#bg-video');
        
        // play/pause bg video
        function toggleMute() {
          
          // mediaPlayer.muted = !mediaPlayer.muted;
          // $('.mute-btn').toggle();
          // $('.unmute-btn').toggle();

          if (mediaPlayer.muted) { // unmute
            mediaPlayer.muted = false; 
            $('#bg-video').prop("muted", false);
            $('.unmute-btn').show();
            $('.mute-btn').hide();
          } else { // mute
            mediaPlayer.muted = true; 
            $('#bg-video').prop("muted", true);
            $('.mute-btn').show();
            $('.unmute-btn').hide();
          }          
        }

        // $(".video-controls").on("click", '.mute-unmute' ,function(){
        $(".video-controls").on("click", '.mute-unmute' ,function(){
          toggleMute();
          console.log('mute toggled');
        });

        // play/pause bg video
        function playPause() {
          // var mediaPlayer = document.getElementById('bg-video');
          // if (mediaPlayer.paused || mediaPlayer.ended) {
          if (mediaPlayer.paused) {
            mediaPlayer.play(); 
            $('.pause-btn').show();
            $('.play-btn').hide();
          } else {
            mediaPlayer.pause(); 
            $('.play-btn').show();
            $('.pause-btn').hide();
          }
        }

        $(".play-pause").on("click", '', function(){
          playPause();
          console.log('play toggled');
        });

        // advance to next slide
        // Advance carousel to next slide when video ends
        mediaPlayer.addEventListener('ended', function() {
          home_carousel.carousel('next'); // Move to the next slide
          console.log('Video ended, advancing to next slide');
        });
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
